export default __webpack_public_path__ + "static/media/404.5f98c7a6.png";